import { render, staticRenderFns } from "./IframeComponent.vue?vue&type=template&id=0f959f44&scoped=true&"
import script from "./IframeComponent.vue?vue&type=script&lang=js&"
export * from "./IframeComponent.vue?vue&type=script&lang=js&"
import style0 from "./IframeComponent.vue?vue&type=style&index=0&id=0f959f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f959f44",
  null
  
)

export default component.exports